import { FeatureFlag } from './feature-flag';

/**
 * Deterministic feature-flag values for offline/hermetic runs.
 *
 * Mirrors the `test` environment's ConfigCat config so hermetic runs behave as they do against live
 * `test`. Two consumers share this single definition, and they must not drift:
 *
 * - `FeatureFlagProvider` serves it via `createFlagOverridesFromMap` when the SDK key is the hermetic
 *   sentinel (hermetic E2E — no ConfigCat CDN call).
 * - The integration harness's MSW ConfigCat handler serves it as its baseline, before any per-spec
 *   `withFeatureFlags` overrides.
 *
 * Typed as `Record<FeatureFlag, boolean>` so adding a flag to `FeatureFlag` without a value here is a
 * **compile error** rather than a silent behavioural difference between environments.
 *
 * Plain data with no React or SDK imports, so it is safe to import from the MSW mock modules that load
 * inside the Next server process.
 */
export const HERMETIC_FEATURE_FLAGS: Record<FeatureFlag, boolean> = {
  [FeatureFlag.dbd1176]: false,
  [FeatureFlag.dbd2341OnboardingMorrisonsLive]: true,
  [FeatureFlag.dbd3882]: true,
  [FeatureFlag.dbd4227ToggleContentLinkCampaigns]: true,
  [FeatureFlag.dbd477]: true,
  [FeatureFlag.dbd880]: true,
  [FeatureFlag.dbd921]: true,
  [FeatureFlag.dpd1338]: true,
  [FeatureFlag.dpd794]: true,
  [FeatureFlag.enableCreatePlanButton]: true,
  [FeatureFlag.lpad313ShowAutomatedCampaigns]: false,
};
